module.exports = __webpack_public_path__ + "img/forbidden.d58e8f09.gif";